<template>
  <div
    class="d-flex justify-content-between mt-3 w-100"
    @click="onClick()"
    style="cursor: pointer"
  >
    <div :style="titleStyle" style="width: 80%">{{ title }}</div>
    <div>
      <div v-if="iconType === 'arrow'">
        <i
          class="fa fa-chevron-right green"
          :class="{
            'rotate-180': isOpen,
            'rotate-0': !isOpen,
          }"
        ></i>
      </div>
      <div v-if="iconType === 'plus_minus'">
        <i v-if="isOpen" class="fa fa-minus" style="color: #2c7040"></i>
        <i v-else class="fa fa-plus"></i>
      </div>
    </div>
  </div>
  <div v-show="isOpen" class="mt-2">
    <p v-html="description" />
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "@vue/runtime-core";
import { onMounted, PropType, ref } from "vue";

export default defineComponent({
  name: "Accordion",
  props: {
    title: {
      type: String,
    },
    titleStyle: Object,
    description: {
      type: String,
    },
    iconType: {
      type: String as PropType<"" | "arrow" | "plus_minus">,
      default: "arrow",
    },
    enableAnimation: {
      type: Boolean,
      default: true,
    },
    defaultOpen: Boolean,
  },
  emits: ["onClick"],
  setup(props, { emit }) {
    const isOpen = ref<boolean>(false);

    onMounted(() => {
      if (props.defaultOpen) {
        isOpen.value = true;
      }
    });

    const onClick = () => {
      if (props.enableAnimation) {
        if (!isOpen.value) {
          emit("onClick");
        }
        isOpen.value = !isOpen.value;
      } else {
        emit("onClick");
      }
    };

    return {
      isOpen,
      onClick,
    };
  },
});
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.rotate-180 {
  transform: rotate(90deg);
  transition: transform 0.25s ease-in-out;
  -webkit-transition: -webkit-transform 0.25s ease-in-out;
}

.rotate-0 {
  transform: rotate(0deg);
  transition: transform 0.25s ease-in-out;
  -webkit-transition: -webkit-transform 0.25s ease-in-out;
}
</style>
